import { render, staticRenderFns } from "./UserFormEdit.vue?vue&type=template&id=3206719a&"
import script from "./UserFormEdit.vue?vue&type=script&lang=js&"
export * from "./UserFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports